export const LOCALSTORAGE_TOKEN = "codart-token";
